import { createSlice } from '@reduxjs/toolkit';

interface parameters {
    id: string | number,
    port: string,
    serviceName: string,
    displayName: string,
    components: string,
}

export interface parametersState {
    isParametersDataLoading: boolean;
    parametersData: Array<parameters>;
    parametersError: boolean;
}

const initialState: parametersState = {
    isParametersDataLoading: false,
    parametersData: [],
    parametersError: false,
}

const parametersReducer = createSlice({
    name: 'parameters',
    initialState: initialState,
    reducers: {
        getParametersDataRequest: (state, action: { payload: string }) => {
            state.isParametersDataLoading = true;
        },
        getParametersDataResponse: (state, action) => {
            state.isParametersDataLoading = false;
            state.parametersData = action.payload.res;
        },
        getParametersDataFailed: (state) => {
            state.isParametersDataLoading = false;
            state.parametersError = true;
        }}
    })


export const parametersActions = parametersReducer.actions;
export default parametersReducer;